import { render, staticRenderFns } from "./workOrderDetail.vue?vue&type=template&id=afc7bc96&scoped=true&"
import script from "./workOrderDetail.vue?vue&type=script&lang=js&"
export * from "./workOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./workOrderDetail.vue?vue&type=style&index=0&id=afc7bc96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc7bc96",
  null
  
)

export default component.exports